<template>
  <RevDialog
    :name="ADDRESS_RULE_DELETE_MODAL_NAME"
    :title="i18n(translations.title)"
  >
    <template #body>
      <div class="px-9 py-7 text-center">
        <span class="body-1"> {{ i18n(translations.body) }}</span>
      </div>
    </template>

    <template #footer="{ close }">
      <div class="flex flex-col items-center">
        <RevButton
          class="mb-7"
          full-width="always"
          variant="primary"
          @click="deleteAddressRule(close, ruleId)"
        >
          {{ i18n(translations.confirmation) }}
        </RevButton>

        <RevButton full-width="always" variant="secondary" @click="close">
          {{ i18n(translations.cancel) }}
        </RevButton>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { merchantsAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'

import { ADDRESS_RULE_DELETE_MODAL_NAME } from '../../AddressRules.constants'

import translations from './DeleteAddressRuleModal.translations'

const i18n = useI18n()
const { openSuccessToast, openErrorToast } = useTheToast()
const emit = defineEmits(['rule-deleted'])
const { ruleId } = defineProps<{
  ruleId: string
}>()

async function deleteAddressRule(close: () => void, id: string) {
  try {
    await $httpFetch(merchantsAPI.deleteAddressRule, {
      pathParams: { id },
    })

    emit('rule-deleted')
    openSuccessToast()
  } catch {
    openErrorToast()
  }

  close()
}
</script>
